var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", attrs: { tag: "form" } },
    [
      _vm.active != null
        ? _c(
            "el-card",
            [
              _c(
                "el-row",
                [
                  _c("app-opcoes-header-analise", {
                    staticClass: "right",
                    attrs: {
                      idProcesso: _vm.idProcesso,
                      protocolo: _vm.protocolo,
                      numeroProcesso: _vm.numeroProcesso,
                      tipoProcesso: _vm.despacho.processo.tipo.codigo,
                      btnSolicitarInformacao: false,
                      btnRetificacao: false,
                      btnNotificarInteressado: false
                    }
                  })
                ],
                1
              ),
              _c(
                "el-steps",
                {
                  staticClass: "margin-top",
                  attrs: {
                    active: _vm.active,
                    "finish-status": "success",
                    simple: "simple"
                  }
                },
                [
                  _c("el-step", { attrs: { title: "Informar dados" } }),
                  _c("el-step", { attrs: { title: "Confirmar dados" } })
                ],
                1
              ),
              _vm.active === 0
                ? _c(
                    "div",
                    [
                      _c("app-divider", {
                        staticClass: "margin-medium-top",
                        attrs: {
                          label:
                            "PORTARIA DE APROVAÇÃO DE DEMARCAÇÃO E HOMOLOGAÇÃO DE PROCESSO DE REGULARIZAÇÃO FUNDIÁRIA ",
                          showBorder: false
                        }
                      }),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Processo: ", required: false }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.portaria.numeroProcesso,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.portaria,
                                      "numeroProcesso",
                                      $$v
                                    )
                                  },
                                  expression: "portaria.numeroProcesso"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Interessado:",
                                  required: false
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.portaria.interessado,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "interessado", $$v)
                                  },
                                  expression: "portaria.interessado"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Municípios: ",
                                              required: true
                                            }
                                          }),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "input",
                                              class: { erro: errors.length },
                                              attrs: {
                                                required: true,
                                                multiple: true
                                              },
                                              model: {
                                                value: _vm.municipiosPortaria,
                                                callback: function($$v) {
                                                  _vm.municipiosPortaria = $$v
                                                },
                                                expression: "municipiosPortaria"
                                              }
                                            },
                                            _vm._l(_vm.municipios, function(m) {
                                              return _c("el-option", {
                                                key: m.id,
                                                attrs: {
                                                  label: m.nome,
                                                  value: m.id
                                                }
                                              })
                                            }),
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1528661260
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 18 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: { label: "Denominação:" }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { name: "denominacao" },
                                            model: {
                                              value: _vm.portaria.denominacao,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "denominacao",
                                                  $$v
                                                )
                                              },
                                              expression: "portaria.denominacao"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2128542935
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Colônia: ", required: false }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: { name: "colonia" },
                                model: {
                                  value: _vm.portaria.colonia,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "colonia", $$v)
                                  },
                                  expression: "portaria.colonia"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Lote: ", required: false }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: { name: "lote" },
                                model: {
                                  value: _vm.portaria.lote,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "lote", $$v)
                                  },
                                  expression: "portaria.lote"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "margin-medium-top" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: { label: "Localização: " }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { name: "localizacao" },
                                            model: {
                                              value: _vm.portaria.localizacao,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "localizacao",
                                                  $$v
                                                )
                                              },
                                              expression: "portaria.localizacao"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1541915939
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Área 1:", required: false }
                              }),
                              _c("app-double-input", {
                                staticClass: "input",
                                attrs: {
                                  name: "area1",
                                  precision: 4,
                                  showAppend: true
                                },
                                model: {
                                  value: _vm.portaria.area1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "area1", $$v)
                                  },
                                  expression: "portaria.area1"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Área 2:", required: false }
                              }),
                              _c("app-double-input", {
                                staticClass: "input",
                                attrs: {
                                  name: "area2",
                                  precision: 4,
                                  showAppend: true
                                },
                                model: {
                                  value: _vm.portaria.area2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "area2", $$v)
                                  },
                                  expression: "portaria.area2"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Área 3:", required: false }
                              }),
                              _c("app-double-input", {
                                staticClass: "input",
                                attrs: {
                                  name: "area3",
                                  precision: 4,
                                  showAppend: true
                                },
                                model: {
                                  value: _vm.portaria.area3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "area3", $$v)
                                  },
                                  expression: "portaria.area3"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required|notZero" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: { label: "Área Total:" }
                                          }),
                                          _c("app-double-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              name: "areaTotal",
                                              precision: 4,
                                              showAppend: true
                                            },
                                            model: {
                                              value: _vm.portaria.areaTotal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "areaTotal",
                                                  $$v
                                                )
                                              },
                                              expression: "portaria.areaTotal"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2295647723
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required|notZero" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: { label: "Área Líquida:" }
                                          }),
                                          _c("app-double-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              name: "areaLiquida",
                                              precision: 4,
                                              showAppend: true
                                            },
                                            model: {
                                              value: _vm.portaria.areaLiquida,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "areaLiquida",
                                                  $$v
                                                )
                                              },
                                              expression: "portaria.areaLiquida"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  670932384
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Área Deduzida:",
                                  required: false
                                }
                              }),
                              _c("app-double-input", {
                                staticClass: "input",
                                attrs: {
                                  name: "areaDeduzida",
                                  precision: 4,
                                  showAppend: true
                                },
                                model: {
                                  value: _vm.portaria.areaDeduzida,
                                  callback: function($$v) {
                                    _vm.$set(_vm.portaria, "areaDeduzida", $$v)
                                  },
                                  expression: "portaria.areaDeduzida"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "margin-medium-top" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required|notZero" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c("app-label", {
                                            attrs: { label: "Perímetro:" }
                                          }),
                                          _c("app-double-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              name: "areaTotal",
                                              precision: 4,
                                              showAppend: true,
                                              appendText: "Metro(s)"
                                            },
                                            model: {
                                              value: _vm.portaria.perimetro,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "perimetro",
                                                  $$v
                                                )
                                              },
                                              expression: "portaria.perimetro"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1273081073
                            )
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Declinação magnética:"
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              name: "declinacaoMagnetica"
                                            },
                                            model: {
                                              value:
                                                _vm.portaria
                                                  .declinacaoMagnetica,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "declinacaoMagnetica",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "portaria.declinacaoMagnetica"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1204101383
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: { label: "Data:" }
                                          }),
                                          _c(
                                            "el-date-picker",
                                            _vm._b(
                                              {
                                                staticClass: "input full-width",
                                                class: { erro: errors.length },
                                                attrs: {
                                                  name: "data",
                                                  type: "month",
                                                  placeholder: "Selecione",
                                                  format: "MM/yyyy"
                                                },
                                                model: {
                                                  value: _vm.portaria.data,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.portaria,
                                                      "data",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "portaria.data"
                                                }
                                              },
                                              "el-date-picker",
                                              _vm.$attrs,
                                              false
                                            )
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3532638212
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: { label: "Vértice:" }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              maxlength: "15",
                                              name: "vertice"
                                            },
                                            model: {
                                              value: _vm.portaria.vertice,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.portaria,
                                                  "vertice",
                                                  $$v
                                                )
                                              },
                                              expression: "portaria.vertice"
                                            }
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  320565979
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            [
                              _c("app-memorial-descritivo", {
                                attrs: {
                                  memorialSalvo:
                                    _vm.portaria.memorialDescritivo,
                                  limitesSalvo: _vm.despacho.limites
                                },
                                on: {
                                  changeMemorial: _vm.changeMemorial,
                                  changeLimites: _vm.changeLimites
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-row", [
                        _c(
                          "div",
                          { staticClass: "buttons-memorial" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { type: "default" },
                                on: { click: _vm.cancelar }
                              },
                              [
                                _c("i", { staticClass: "fa fa-times" }),
                                _vm._v("  Cancelar")
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { type: "success" },
                                on: { click: _vm.proximo }
                              },
                              [
                                _c("i", { staticClass: "fa fa-chevron-right" }),
                                _vm._v("  Próximo")
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "div",
                      [
                        this.bytes != null
                          ? _c(
                              "div",
                              { staticClass: "container" },
                              [
                                _c("h2", [_vm._v("Minuta da Portaria")]),
                                _c("app-pdf-viewer", {
                                  attrs: {
                                    bytes: _vm.bytes,
                                    nomeDocumento: "Minuta da portaria.pdf"
                                  }
                                }),
                                _c(
                                  "div",
                                  { staticClass: "flex-center" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "success"
                                        },
                                        on: { click: _vm.downloadPdf }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fal fa-file-pdf"
                                        }),
                                        _c("span", [_vm._v("  Exportar PDF")])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("app-radios-tramitacao", {
                          attrs: {
                            radios: _vm.radios,
                            isDecisao: _vm.isDecisao,
                            portariaComNumero: _vm.portaria.numero
                          },
                          on: { changeRadio: _vm.changeRadio }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "buttons-memorial" }, [
                      _c(
                        "div",
                        { staticClass: "float-left" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "default" },
                              on: { click: _vm.voltar }
                            },
                            [
                              _c("i", { staticClass: "fa fa-chevron-left" }),
                              _vm._v("  Voltar")
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "default" },
                              on: { click: _vm.cancelar }
                            },
                            [
                              _c("i", { staticClass: "fa fa-times" }),
                              _vm._v("  Cancelar")
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "float-right" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "success" },
                              on: { click: _vm.finalizarPortaria }
                            },
                            [
                              _c("i", { staticClass: "fa fa-check" }),
                              _vm._v("  Finalizar")
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-693d70b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693d70b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/Portaria.vue
// module id = null
// module chunks = 